import {BOT_CONV_MESSAGE_TYPE} from '../../../../helpers/consts/common-consts';
import './text-message.css';
import ReactMarkdown from "react-markdown";
import HtmlMessage, {isHtmlContent, extractHtml} from "../html-message";

// relative time https://day.js.org/docs/en/plugin/relative-time
export default function TextMessage({senderType, message, chatBotSetting, onInvokeAction, disabled}) {
  // A TEXT payload wrapped in <html>…</html> is rendered as (sanitized) HTML
  // instead of markdown. Everything else takes the markdown path unchanged.
  if (isHtmlContent(message)) {
    return (
      <HtmlMessage
        html={extractHtml(message)}
        onInvokeAction={onInvokeAction}
        disabled={disabled}
      />
    );
  }

  // Convert plain URLs/emails to markdown links so ReactMarkdown renders them as anchors
  const autoLink = (text) => {
    if (!text || typeof text !== 'string') return '';
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|(mailto:[^\s]+)|([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return text.replace(urlRegex, (match) => {
      let href = match;
      // Email: add mailto: if plain email
      if (emailRegex.test(href)) {
        href = `mailto:${href}`;
      } else {
        // Add scheme for www. links (but not for mailto:)
        if (!/^https?:\/\//i.test(href) && !/^mailto:/i.test(href)) {
          href = `https://${href}`;
        }
      }
      return `[${match}](${href})`;
    });
  };

  const enhancedMessage = autoLink(message);

  return (
    <ReactMarkdown 
    className={`prose chat-text-bubble ${senderType === BOT_CONV_MESSAGE_TYPE ? 'chat-bot-bubble' : 'chat-user-bubble'}`}
    style={senderType === BOT_CONV_MESSAGE_TYPE ? undefined : { backgroundColor: chatBotSetting?.headerBackgroundColor, color: chatBotSetting?.headerTextColor }}
    components={{
      a: ({node, ...props}) => (
        <a
          {...props}
          target="_blank"
          rel="noopener noreferrer"
        />
      ),
    }}
    >
      {enhancedMessage}
    </ReactMarkdown>
  );
}

